// ProtectedRoute.js
import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";

class ProtectedRoute extends Component {
  isConfirmed = () => {
    const PUBLIC_PATHS = [
      "/index.html",
      "/splashscreen",
      "/desktop_ktbst",
      "/ktbst_browser_suitable",
      "/clear_data",
    ];
    const currentPath = window.location.pathname;

    if (PUBLIC_PATHS.includes(currentPath)) return true;

    // localStorage ว่างทั้งหมด → redirect
    if (localStorage.length === 0) return false;

    const tcconfirm = JSON.parse(localStorage.getItem("tcconfirm"));

    // ยังไม่มีค่า → ผ่านได้เลย
    if (tcconfirm === null || tcconfirm?.confirm === undefined) return true;

    return tcconfirm.confirm === 1;
  };
  handleNotConfirmed = () => {
    const tcconfirm = localStorage.getItem("tcconfirm");
    localStorage.clear();
    localStorage.setItem("tcconfirm", tcconfirm);
  };

  componentDidMount() {
    window.addEventListener("pageshow", this.handlePageShow);
    window.addEventListener("popstate", this.handlePopState);
  }

  componentWillUnmount() {
    window.removeEventListener("pageshow", this.handlePageShow);
    window.removeEventListener("popstate", this.handlePopState);
  }

  handlePageShow = (e) => {
    if (e.persisted && !this.isConfirmed()) {
      this.handleNotConfirmed();
      window.location.replace("/index.html");
    }
  };

  handlePopState = () => {
    if (!this.isConfirmed()) {
      this.handleNotConfirmed();
      window.location.replace("/index.html");
    }
  };
  render() {
    const { component: Component, render: renderProp, ...rest } = this.props;

    return (
      <Route
        {...rest}
        render={(props) => {
          if (this.isConfirmed()) {
            return Component ? <Component {...props} /> : renderProp(props);
          }
          this.handleNotConfirmed();
          return <Redirect to="/index.html" />;
        }}
      />
    );
  }
}

export default ProtectedRoute;
